import { action, makeObservable, observable } from "mobx";
import { privatePost } from "../utils/NetworkService";
import { setSessionJson, getSessionJson } from '../utils/SessionService';
// import { debug } from "../utils/UtilConsole";
// import { getTokenBalance, getEtherBalance } from '../utils/TokenService';
// import { Navigate } from 'react-router-dom';

class RecommenderInfoState {

    business_code;
    business_grade;
    business_level;
    business_user_count;
    shared_friend_list;
    recommender_member_nickname;
    recommender_reg_time;
    recommender_reg_code;
    shared_recommender_friend_list;
    business_level_info;
    constructor(memberData) {
        // console.log(memberData);
        this.business_code = memberData?.business_code ?? null;
        this.business_grade = memberData?.business_grade ?? null;
        this.business_level = memberData?.business_level ?? null;
        this.business_user_count = memberData?.business_user_count ?? null;
        this.shared_friend_list = memberData?.shared_friend_list ?? null;
        this.recommender_member_nickname = memberData?.recommender_member_nickname ?? null;
        this.recommender_reg_time = memberData?.recommender_reg_time ?? null;
        this.recommender_reg_code = memberData?.recommender_reg_code ?? null;
        this.shared_recommender_friend_list = memberData?.shared_recommender_friend_list ?? null;
        this.business_level_info = memberData?.business_level_info ?? null;



    }
}


class registVerificationState {
    verification;
    verification_time;
    member_no;
    verify_code;
    reg_time;
    constructor(VerificationData) {
        this.verification = VerificationData?.verification ?? null;
        this.verification_time = VerificationData?.verification_time ?? null;
        this.member_no = VerificationData?.member_no ?? null;
        this.verify_code = VerificationData?.verify_code ?? null;
        this.reg_time = VerificationData?.reg_time ?? null;
    }
}




export class UserProfileStore {
    rootStore;

    RecommenderInfoState = getSessionJson('RecommenderInfo') ? new RecommenderInfoState(getSessionJson('RecommenderInfo'), null) : new RecommenderInfoState();
    registVerificationState = getSessionJson('VerificationData') ? new registVerificationState(getSessionJson('VerificationData'), null) : new registVerificationState();


    UserFriendRecommenderList = [];
    UserFriendList = [];
    UserFollowerList = [];
    UserRecommenderInfo = [];
    copyFriendList = [];
    businessLevelUpgrade = [];
    FriendCount = [];


    VerifyPhoneNumber = '';
    VerifyCode = '';
    GuideAuthentication = '';
    GuideUserPage = '';



    ShareValue = 0;
    UserFriendButton = 0;
    setUserFriendListLength = 0;


    FriendListShareBool = false;
    VerifyShareBool = false;
    authenticationCheck = false;
    PhoneNumberButton = false;




    constructor(root) {
        makeObservable(this, {
            RecommenderInfoState: observable,
            UserFriendRecommenderList: observable,
            UserFriendList: observable,
            UserFollowerList: observable,
            UserFriendButton: observable,
            UserRecommenderInfo: observable,
            businessLevelUpgrade: observable,
            ShareValue: observable,
            copyFriendList: observable,
            FriendListShareBool: observable,
            FriendCount: observable,
            VerifyPhoneNumber: observable,
            VerifyShareBool: observable,
            authenticationCheck: observable,
            GuideAuthentication: observable,
            PhoneNumberButton: observable,
            GuideUserPage: observable,
            setUserFriendListLength: observable,















            setGuideUserPage: action,
            setPhoneNumberButton: action,
            setregistVerify: action,
            setVerifyCheck: action,
            setPersonalInformationConsentCheck: action,
            registVerification: action,
            setVerifyCode: action,
            setSendVerifyMessage: action,
            setVerifyPhoneNumber: action,
            setFriendCount: action,
            getFriendCount: action,
            setFriendShareChange: action,
            setRecommenderInfoState: action,
            FriendListShareBoolChange: action,
            setcopyFriendList: action,
            getcopyFriendList: action,
            setSharedFriendList: action,
            setbusinessLevelUpgrade: action,
            getbusinessLevelUpgrade: action,
            getRecommenderInfo: action,
            setRecommenderInfo: action,
            setUserFriendButton: action,
            setUserFollowerList: action,
            getUserFollowerList: action,
            setUserFriendList: action,
            getUserFriendList: action,
            getUserFriendRecommenderList: action,
            setUserFriendRecommenderList: action,

        });

        this.rootStore = root;
        this.RecommenderInfoState = getSessionJson('RecommenderInfo') ? new RecommenderInfoState(getSessionJson('RecommenderInfo'), null) : new RecommenderInfoState();
        this.registVerificationState = getSessionJson('VerificationData') ? new registVerificationState(getSessionJson('VerificationData'), null) : new registVerificationState();
        this.UserFriendRecommenderList = [];
        this.UserFriendList = [];
        this.UserFollowerList = [];
        this.UserRecommenderInfo = [];
        this.businessLevelUpgrade = [];
        this.copyFriendList = [];
        this.FriendCount = [];


        this.VerifyPhoneNumber = '';
        this.VerifyCode = '';
        this.GuideAuthentication = '';
        this.GuideUserPage = '';






        this.ShareValue = 0;
        this.UserFriendButton = 0;
        this.setUserFriendListLength = 0;


        this.FriendListShareBool = false;
        this.VerifyShareBool = false;
        this.authenticationCheck = false;
        this.PhoneNumberButton = false;




    }


    setUserFriendButton(vlaue) {
        if (vlaue === 0) {
            this.UserFriendButton = 0;
            this.getUserFriendList();
        }
        else if (vlaue === 1) {
            this.UserFriendButton = 1;
            this.getUserFollowerList();
        }
        else if (vlaue === 2) {
            this.UserFriendButton = 2;
            this.getUserFriendRecommenderList();
        }
    }


    getFriendCount = (e) => {//친구 창 카운터 불러오기
        const api = "/getFriendCount";
        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no) } }, (err, response) => {
            if (err) {
                // console.log("getFriendCount",err);
                // debug("getFriendCount",err);

            }
            else {
                if (response?.data?.result) {
                    // debug("getFriendCount",response?.data?.result);
                    this.setFriendCount(response?.data?.result);
                    // eslint-disable-next-line
                    if (e != "List") {
                        this.getUserFriendList("HI");
                    }
                }
            }
        });
    }

    setFriendCount(object) {//친구 창 카운터 저장
        // debug(object);
        this.FriendCount = object;
    }

    getUserFriendRecommenderList = (e) => {//추천인친구목록 불러오기
        const api = "/getPresenterList";
        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no) } }, (err, response) => {
            if (err) {
                // debug("getUserFriendRecommenderList",err);
                this.setGuideUserPage(this.rootStore?.loginStore?.ErrorGuide_clover_001);//새로고침을 해주세요
            }
            else {
                if (response?.data?.result) {
                    // debug("getUserFriendRecommenderList",response?.data?.result);
                    // this.setUserFriendRecommenderList(response?.data?.result);
                    // eslint-disable-next-line
                    response?.data?.result.map((item) => item.member_country == undefined || item.member_country == null || item.member_country == "" ?
                        this.setUserFriendRecommenderList({ ...item, member_country: "kr" })
                        :
                        this.setUserFriendRecommenderList(item)
                    )
                    // eslint-disable-next-line
                    if (response?.data?.result?.length == 0) {
                        this.setGuideUserPage(this.rootStore?.loginStore?.Guide_clover_userProfile_01);//추천인 목록이 없습니다
                    }
                    this.getFriendCount("List");
                }
            }
        });
    }

    setUserFriendRecommenderList(object) {//추천인친구목록 변수 저장
        // console.log("setUserFriendRecommenderList", object);
        const List = this.UserFriendRecommenderList;
        List.push(object);
        // this.UserFriendRecommenderList = object;
    }


    getUserFriendList = (e) => {//친구목록 불러오기
        // console.log(e);
        const api = '/getFriendList';
        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no) } }, (err, response) => {
            if (err) {
                // debug("getUserFriendList",err);
                this.setGuideUserPage(this.rootStore?.loginStore?.ErrorGuide_clover_001);//새로고침을 해주세요
            }
            else {
                if (response?.data?.result) {
                    // debug("getUserFriendList",response?.data?.result);
                    // eslint-disable-next-line
                    response?.data?.result.map((item) => item.member_country == undefined || item.member_country == null || item.member_country == "" ?
                        this.setUserFriendList({ ...item, member_country: "kr" })
                        :
                        this.setUserFriendList(item)
                    )
                    // this.setUserFriendList(response?.data?.result);
                    // eslint-disable-next-line
                    if (response?.data?.result?.length == 0) {
                        this.setGuideUserPage(this.rootStore?.loginStore?.Guide_clover_userProfile_02);// 친구 목록이 없습니다
                    }
                    else {
                        this.setUserFriendListLength = response?.data?.result?.length;
                    }
                    this.getFriendCount("List");
                }
            }
        });
    }


    setUserFriendList(object) {//친구목록 변수 저장
        // console.log("setUserFriendList", object);
        const List = this.UserFriendList;
        List.push(object);
    }



    getUserFollowerList = () => {//팔로워 리스트 불러오기
        const api = '/getFollowerList';

        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no) } }, (err, response) => {
            if (err) {
                // debug("getUserFollowerList",err);
                this.setGuideUserPage(this.rootStore?.loginStore?.ErrorGuide_clover_001);//새로고침을 해주세요
            }
            else {
                if (response?.data?.result) {
                    // debug("getUserFollowerList",response?.data?.result);
                    // eslint-disable-next-line
                    response?.data?.result.map((item) => item.member_country == undefined || item.member_country == null || item.member_country == "" ?
                        this.setUserFollowerList({ ...item, member_country: "kr" })
                        :
                        this.setUserFollowerList(item)
                    )
                    // this.setUserFollowerList(response?.data?.result);
                    // eslint-disable-next-line
                    if (response?.data?.result?.length == 0) {
                        this.setGuideUserPage(this.rootStore?.loginStore?.Guide_clover_userProfile_03);//팔로우 목록이 없습니다 
                    }
                    this.getFriendCount("List");
                }
            }
        });
    }



    setUserFollowerList(object) {//팔로워 리스트 변수 저장
        // debug("setUserFollowerList",object);
        const List = this.UserFollowerList;
        List.push(object);
    }



    setGuideUserPage(value) {
        this.GuideUserPage = value;
    }






    /**등급정보 불러오기 */
    async getRecommenderInfo(value) {
        // console.log(value);
        const api = '/getRecommenderInfo';
        await privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no) } }, (err, response) => {
            if (err) {
                // console.log(err);
                // eslint-disable-next-line
                if (err.errorCode == 3100) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_01);//유저를 찾을 수 없습니다
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3101) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_02);//등급이 해당되지 않습니다
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3200) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_03);//다음 레벨을 찾을 수 없습니다
                }
                // eslint-disable-next-line
                else if (err.errorCode == 2401) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_814);//클로버가 부족합니다
                }
                // eslint-disable-next-line
                else if (err.errorCode == 2400) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_2400);//클로버 구매를 실패하였습니다
                }
            }
            else {
                if (response?.data?.result) {
                    this.setRecommenderInfo(response?.data?.result);
                    this.setRecommenderInfoState(response?.data?.result);
                    if (response?.data?.result?.business_grade > 0) {
                        this.rootStore.loginStore.setIsRecommenderPage(true);
                    }
                    else {
                        if (this.rootStore.loginStore.Usercountry) {
                            this.rootStore.loginStore.setOverseasLogin(this.rootStore.loginStore.Usercountry); // 해외 유저 체크(자동추천)
                        }
                        this.rootStore.loginStore.setIsRecommenderPage(false);
                    }
                    if (response?.data?.result?.business_grade > 0) {
                        this.rootStore.CoinStore.getWalletData("OK");
                    }
                    if (response?.data?.result?.business_grade) {
                        this.rootStore.MissionStore.getUserMissionLevelInfo("business_grade", "Amount");
                    }
                }
            }
        }, "recommender");
    }

    setRecommenderInfo(object) {
        this.UserRecommenderInfo = object;
    }

    /** 등급업 */
    getbusinessLevelUpgrade = () => {
        const api = '/businessLevelUpgrade';
        // debug("getbusinessLevelUpgrade",parseInt(this.rootStore.loginStore.loginState.member_no));
        // debug("getbusinessLevelUpgrade",typeof parseInt(this.rootStore.loginStore.loginState.member_no));
        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no) } }, (err, response) => {
            if (err) {
                // console.log(err);
                if (err.errorCode == 3100) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_01);//유저를 찾을 수 없습니다
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3101) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_02);//등급이 해당되지 않습니다
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3200) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_03);//다음 레벨을 찾을 수 없습니다
                }
                // eslint-disable-next-line
                else if (err.errorCode == 2401) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_814);//클로버가 부족합니다
                }
                // eslint-disable-next-line
                else if (err.errorCode == 2400) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_2400);//클로버 구매를 실패하였습니다
                }
            }
            else {
                if (response?.data?.result) {
                    // debug("getbusinessLevelUpgrade",response?.data?.result);
                    this.setbusinessLevelUpgrade(response?.data?.result);
                    this.getRecommenderInfo("RecommenderInfobusinessLevelUpgrade");
                }
            }
        });
    }


    setbusinessLevelUpgrade(object) {
        this.rootStore.loginStore.getCloverCount("RecommenderInfoEnd");
        this.businessLevelUpgrade = object;

    }


    /**추천인 자동 체크 (친구 공유 ) */
    FriendListShareBoolChange(AuthCode) {
        const api = '/setSharedFriendList';

        if (AuthCode === undefined || AuthCode === null || AuthCode === "") {
            this.FriendListShareBool = false;
            this.ShareValue = 0;
        }
        else {
            this.FriendListShareBool = true;
            this.ShareValue = 1;
        }

        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no), shared: this.ShareValue } }, (err, response) => {
            if (err) {
                // console.log(err);
            }
            else {
                if (response?.data?.result) {
                    this.setFriendShareChange(response?.data?.result.shared);
                }
            }
        });

    }


    /**친구 공유 */
    setSharedFriendList = (value) => {
        const api = '/setSharedFriendList';
        if (value === true) {
            this.ShareValue = 1;
        }
        else if (value === false) {
            this.ShareValue = 0;
        }
        privatePost({ api: api, data: { member_no: this.rootStore.loginStore.loginState.member_no, shared: this.ShareValue } }, (err, response) => {
            if (err) {
                // console.log(err);
            }
            else {
                if (response?.data?.result) {
                    this.setFriendShareChange(response?.data?.result.shared);
                    if (this.ShareValue === 1) {
                        if (window.confirm(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_05) === true) {//친구를 복사하시겠습니까?
                            this.getcopyFriendList();
                        }
                    }
                }
            }
        });

    }

    setVerifyPhoneNumber(object) {
        this.VerifyPhoneNumber = object.target.value;
    }

    setSendVerifyMessage = () => {
        const api = "/sendVerifyMessage";
        privatePost({ api: api, data: { member_no: this.rootStore.loginStore.loginState.member_no, phone_no: this.VerifyPhoneNumber } }, (err, response) => {
            if (err) {
                // eslint-disable-next-line
                if (err.errorCode == 3700) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_3700);//휴대전화 번호를 확인해 주세요.
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3703) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_3703);//금일 전송가능 문자개수를 초과하였습니다
                }
            }
            else {
                if (response?.data?.result) {
                    this.setPhoneNumberButton(true);
                    return
                }
            }
        });
    }

    setPhoneNumberButton(bool) {
        this.PhoneNumberButton = bool;
    }

    setVerifyCode(object) {
        this.VerifyCode = object.target.value;
    }

    registVerification = () => {
        const api = "/registVerification";
        privatePost({ api: api, data: { member_no: this.rootStore.loginStore.loginState.member_no, verify_code: this.VerifyCode } }, (err, response) => {
            if (err) {
                // eslint-disable-next-line
                if (err.errorCode == 704) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_04);//다시 확인 해주세요
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3701) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_3701);//잘못된 코드 이거나 입력 시간이 초과 되었습니다.
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3702) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_3702);//이미 인증 완료 되었습니다.
                }
            }
            else {
                if (response?.data?.result) {
                    this.setregistVerify(true);
                    this.rootStore.loginStore.setDialogClose("VerifyFalse");
                }
            }
        });
    }

    setregistVerify(bool) {
        this.authenticationCheck = bool;
        this.GuideAuthentication = this.rootStore?.loginStore?.Guide_clover_userProfile_04;// 인증확인 되었습니다
    }


    /** 개인정보 처리 동의 */
    setPersonalInformationConsentCheck(bool) {
        // eslint-disable-next-line
        if (bool == true) {
            this.VerifyShareBool = true;
        }
        // eslint-disable-next-line
        else if (bool == false) {
            this.VerifyShareBool = false;
        }
    }

    setVerifyCheck(check) {
        alert(this.rootStore?.loginStore?.Guide_clover_userProfile_05);//인증완료 되었습니다
        this.setPersonalInformationConsentCheck(true);
        return this.rootStore.loginStore.setDialogClose("AuthenticationFalse");
    }



    setregistVerificationStore(VerificationData) {
        this.registVerificationState = new registVerificationState(VerificationData);
    }

    setFriendShareChange(shared) {
        if (shared) {
            this.RecommenderInfoState = new RecommenderInfoState({ ...this.RecommenderInfoState, shared_friend_list: shared });
        } else {
            this.RecommenderInfoState = new RecommenderInfoState({ ...this.RecommenderInfoState, shared_friend_list: null });
        }
    }


    getcopyFriendList = () => {
        const api = '/copyFriendList';
        privatePost({ api: api, data: { member_no: this.rootStore.loginStore.loginState.member_no } }, (err, response) => {
            if (err) {
                // console.log(err);
                if (parseInt(err.errorCode) === 3300) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_05);//추천인이 없습니다
                }
                else if (parseInt(err.errorCode) === 3301) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_06);//정보를 찾을 수 없습니다
                }
                else if (parseInt(err.errorCode) === 3302) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_07);//추천인이 친구 리스트를 공유 하지 않습니다
                }
                else if (parseInt(err.errorCode) === 3303) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_08);//추천인이 친구로 등록한 사람이 없습니다
                }
            }
            else {
                if (response?.data?.result) {
                    this.setcopyFriendList(response?.data?.result);
                }
            }
        });

    }

    setcopyFriendList = async (object) => {
        this.copyFriendList = object;
    }



    setRecommenderInfoState(RecommenderInfoData) {
        this.RecommenderInfoState = new RecommenderInfoState(RecommenderInfoData);
        if (RecommenderInfoData)
            setSessionJson('RecommenderInfo', RecommenderInfoData);
    }


}
